import { Page } from "table-engine";
import { userTable } from "./config/tables";

export default function TableEngine() {
    return <Page table={userTable} />;
}
